import React from "react";
import "./loading.css";

const Loading = () => {
  return (
    <div className="loading">
      <h1>Loading...</h1>
    </div>
  );
};

export default Loading;
